import React from 'react';
import { Link } from 'react-router-dom';
import SingleBlogTwo from '../../components/Blog/SingleBlogTwo';
import Button from '../../components/Button';

import shapeImg from '../../assets/img/choose/shape-1-2.png';
import blogImg1 from '../../assets/img/blog/blog-3-1.jpg';
import blogImg2 from '../../assets/img/blog/blog-3-2.jpg';

const Blog = () => {
  return (
    <div
      id="it-blog"
      className="it-blog-2-area it-blog-style-4 p-relative pb-90"
    >
      <div className="it-blog-2-shape-1 d-none d-xl-block">
        <img src={shapeImg} alt="" />
      </div>
      <div className="container">
        <div className="row align-items-center">
          <div
            className="col-xl-4 col-lg-4 col-md-6 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".3s"
          >
            <div className="it-blog-title-box">
              <span className="it-section-subtitle ">Our Blog</span>
              <h3 className="it-section-title">
                Our Latest <br /> News & Blogs
              </h3>
              <div className="it-blog-2-text mt-20 mb-40">
                <p>
                  Neque porro quisquam est, qui dolorem ipsum quia dolor sit
                  amet, consectetur, adipisci velit, sed quia nonm.
                </p>
              </div>
              <Link className="it-btn-theme mr-30" to="/blog">
                <Button btnText="View all Article" />
              </Link>
            </div>
          </div>
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <SingleBlogTwo
              blogImage={blogImg1}
              publishedDate="15 JUNE, 24"
              titleClass="hover-anim"
              title="Healthcare Tips Navigating Business Patient Care"
              description="Lorem ipsum dolor sit a met, consectetur adipiscing elit, sed
                  eiusmod tempor incididunt ut labore et dolore magna aliqua."
              btnClass="it-btn-theme blog-btn"
            />
          </div>
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <SingleBlogTwo
              blogImage={blogImg2}
              publishedDate="15 JUNE, 24"
              titleClass="hover-anim"
              title="Healthcare Tips Navigating Business Patient Care"
              description="Lorem ipsum dolor sit a met, consectetur adipiscing elit, sed
                  eiusmod tempor incididunt ut labore et dolore magna aliqua."
              btnClass="it-btn-theme blog-btn"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
